// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","first-table-shrink-width":"1050px","pageContainer":"PalletsPage_pageContainer__eyKP+","pageLoader":"PalletsPage_pageLoader__VmU6X"};